import * as types from "../constants";

const initialState = {
	game: window.currentGame || {},
	channel: window.g_channel || {},
};

const getSchedule = (state = initialState, action) =>
{
	switch (action.type)
	{
		case types.GET_GAME:
			return {...state, game: {...action.game}};
		case types.GET_CHANNEL:
			return {...state, channel: {...action.channel}};
		default:
			return state;
	}
};

export default getSchedule;